import { ComboBoxDoubleLineOption } from '../../cdl/ComboBox/ComboBox';
import type { ComboBoxOptionComponentProps } from '../../cdl/ComboBox/types/ComboBoxComponentProps';
import { formatCompanyName } from '../../common/helpers/formatCompanyName.helper';
import { formatPort } from '../../common/helpers/formatPort.helper';
import { formatVessel } from '../../common/helpers/formatVessel.helper';
import { translate } from '../../common/helpers/translate.helper';

import type { IntegrationOfferSelectOption } from './IntegrationOfferSelect';

export const IntegrationOfferDoubleLineOption = ({
    option,
}: ComboBoxOptionComponentProps<IntegrationOfferSelectOption>) => {
    const vesselName = formatVessel({ vessel: option.offer.vessel });
    const companyName = formatCompanyName({ company: option.offer.customer }) || '';

    const description = option.offer.port
        ? translate('integrationsOverview.orderOption', {
              vesselName,
              portName: formatPort({ port: option.offer.port }),
              companyName,
          })
        : translate('integrationsOverview.orderOptionWithoutPort', { vesselName, companyName });

    return <ComboBoxDoubleLineOption title={option.label} description={description} />;
};
